import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./style/fresh.css";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store";
import reportWebVitals from "./reportWebVitals";
import "react-app-polyfill/stable";
import "core-js/stable";
import "regenerator-runtime/runtime";
import "./style/normalize.css";
import { BrowserRouter } from "react-router-dom";

const rootElement = document.getElementById("root");

// Reuse pre-rendered markup produced by react-snap when it is available.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </React.StrictMode>,
  );
} else {
  // Development mode starts with an empty root and uses the normal client render.
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </React.StrictMode>,
  );
}

reportWebVitals();
